import { useMemo } from "react"
import BadgeCard from "./BadgeCard"

const OscProgressInfo = () => {

    const steps = useMemo( () => {
        return 13
    }, [ ] )

    const accomplishedSteps = useMemo( () => {
        return 4
    }, [ ] )

    const percentage = useMemo( () => {

        const current = accomplishedSteps !== 0 ? accomplishedSteps : 1
        return ( current * 100 / ( steps !== 0 ? steps : 1 ) )
    }, [ steps, accomplishedSteps ] )

    return (
        <div className="bg-white h-full p-4 pt-10 ">
            <div className="flex items-center w-full h-3 border" >
                <span style={{ width: `${percentage}%`}} className="bg-green-500 h-full" />
            </div>
            <div className="flex justify-between mb-4">
                <span>Progresso</span>
                <span>{accomplishedSteps }/{ steps }</span>
            </div>
            <div className="flex justify-between mb-2">
                <span>Conquistas</span>
            </div>
            <div className="grid grid-cols-4 gap-4">
                <span className="w-11 h-11 flex items-center justify-center shadow"></span>
                <span className="w-11 h-11 flex items-center justify-center shadow"></span>
                <span className="w-11 h-11 flex items-center justify-center shadow"></span>
                <span className="w-11 h-11 flex items-center justify-center shadow"></span>
            </div>
            <div className="flex justify-between mb-2">
                <span>Proximas Conquistas</span>
            </div>
            <div className="grid gap-2">
                <BadgeCard
                    name="Análise completa"
                    description="Preencheu 100% dos testes disponiveis"
                    icon={ <span className="w-11 h-11 flex items-center justify-center shadow"></span> }
                />
                <BadgeCard
                    name="Análise completa"
                    description="Preencheu 100% dos testes disponiveis"
                    icon={ <span className="w-11 h-11 flex items-center justify-center shadow"></span> }
                />
                <BadgeCard
                    name="Análise completa"
                    description="Preencheu 100% dos testes disponiveis"
                    icon={ <span className="w-11 h-11 flex items-center justify-center shadow"></span> }
                />
            </div>
        </div>
    )
}


export default OscProgressInfo
